module.exports = __webpack_public_path__ + "static/media/student-snapshort1-next.3134986d.png";